// URLs usando proxy para evitar CORS
const API_BASE_URL = 'https://du2qzoaok4.execute-api.us-east-2.amazonaws.com/dev';

const endpoints = {
  createCustomer: async (data) => {
    const response = await fetch(`${API_BASE_URL}/create-customer`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    return await response.json();
  },
  generateCaptureContext: async (data) => {
    const response = await fetch(`${API_BASE_URL}/capture-context`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    return await response.json();
  },
  createPayment: async (data) => {
    const response = await fetch(`${API_BASE_URL}/create-payment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });
    return await response.json();
  }
};

export default endpoints;
